import { render, staticRenderFns } from "./DynamicContent.vue?vue&type=template&id=a0bd65c0&scoped=true"
import script from "./DynamicContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicContent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DynamicContent.vue?vue&type=style&index=0&id=a0bd65c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bd65c0",
  null
  
)

export default component.exports